import React from 'react';
import Helmet from 'react-helmet';
import { Layout } from 'antd';
import Header from '../Header';
import Footer from '../Footer';
import './main.css';
import icon from '../../../assets/favicon.ico';
import constants from '../../../core/constants';
import { MainProps } from './types';

const {
    APP_NAME,
} = constants;

const Main = (props:MainProps) => {

    const {
        children,
        title,
        toolbar,
        className,
        menu,
        showHeader,
        beforeHeader,
        afterHeader,
        floatingHeader,
        showFooter,
        beforeFooter,
        afterFooter,
        floatingFooter,
        footerContent,
        menuPlacement,
        menuWidth,
        hideSubHeader,
        subHeaderTitle,
        subHeaderHasBackLink,
        subHeaderLeftAction,
        subHeaderRightAction,
        subHeaderBackLinkCallback,
        subHeaderBackLink,
        subHeaderUseCloseIcon,
    } = props;

    return (
        <div className={`page-wrap ${className}`}>
            <Helmet
                title={typeof title === 'object' ? title.props.children : title}
                titleTemplate={`%s - ${APP_NAME}`}
                defaultTitle={`${APP_NAME}`}
                meta={[
                    { name: 'description', content: `${APP_NAME} website` },
                    { property: 'og:type', content: 'website' },
                ]}>
                <link rel="shortcut icon" href={icon} />
            </Helmet>
            {showHeader
                ? (
                    <Header
                        hideSubHeader={hideSubHeader}
                        subHeaderTitle={subHeaderTitle}
                        subHeaderHasBackLink={subHeaderHasBackLink}
                        subHeaderLeftAction={subHeaderLeftAction}
                        subHeaderRightAction={subHeaderRightAction}
                        subHeaderBackLinkCallback={subHeaderBackLinkCallback}
                        subHeaderBackLink={subHeaderBackLink}
                        subHeaderUseCloseIcon={subHeaderUseCloseIcon}
                        afterHeader={afterHeader}
                        beforeHeader={beforeHeader}
                        floating={floatingHeader}
                        // title={headerTitle}
                        toolbar={toolbar}
                        // backLink={backLink}
                        menu={menu}
                        menuPlacement={menuPlacement}
                        menuWidth={menuWidth} />
                )
                : null}
            <Layout.Content>
                {/* {breadcrumb ? <BreadcrumbNav navigation={breadcrumb} /> : null} */}
                {children}
            </Layout.Content>
            {showFooter
                ? (
                    <Footer
                        beforeFooter={beforeFooter}
                        afterFooter={afterFooter}
                        floating={floatingFooter}>
                        {footerContent}
                    </Footer>
                )
                : null}
        </div>
    );
};

Main.defaultProps = {
    afterFooter: null,
    afterHeader: null,
    beforeFooter: null,
    beforeHeader: null,
    logo: '',
    showFooter: true,
    showHeader: true,
    headerTitle: '',
    hideSubHeader: false,
    subHeaderTitle: '',
    subHeaderHasBackLink: false,
    subHeaderUseCloseIcon: false,
    subHeaderLeftAction: '',
    subHeaderRightAction: '',
    subHeaderBackLinkCallback: () => console.log('Back'),
    subHeaderBackLink: '#',
};

export default Main;
